export const authEndpoints = {
  // TenantHub 2-step login (via BFF proxy).
  discover: () => '/auth/discover',
  authenticate: () => '/auth/authenticate',
  // Login-time RBAC lookup — lives under /api/v1/mobile/* so it inherits the
  // BFF's TenantMiddleware exclusion (no per-user tenant context during login).
  rolePermissionsByRoles: () => '/mobile/role-permissions/by-roles',
  // TenantHub refresh proxy — the BFF forwards to Keycloak so the new access
  // token is Keycloak-signed (matches Authentication:DefaultProvider=Keycloak).
  // Do NOT use `/auth/refresh` — that's a template-only local HMAC re-issue
  // that this project's Keycloak-configured JwtBearer would reject.
  refresh: () => '/auth/refresh-hub',
  logout: () => '/auth/logout',
};

export const sessionEndpoints = {
  context: () => '/session/context',
};
